import { render } from "./index.vue?vue&type=template&id=4099b5c8"
import script from "./industries.js?vue&type=script&lang=js&external"
export * from "./industries.js?vue&type=script&lang=js&external"

import "./industries.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__